<div class="w-full rounded-xl border border-gray-100 bg-white shadow-sm">
  <h4 class="border-b border-gray-100 px-5 py-4 font-lato text-sm font-bold uppercase tracking-wide text-blue-950">
    Key Project Contacts
  </h4>
  <div class="divide-y divide-gray-100">
    @for (i of data; track $index) {
      <div class="px-5 py-4">
        <p class="font-lato text-xs font-semibold uppercase tracking-wide text-brand-muted">{{ i.position }}</p>
        <div class="mt-3 grid grid-cols-2 gap-x-4 gap-y-3">
          @if (i.name) {
            <div>
              <p class="font-lato text-xs text-brand-muted">Name</p>
              <p class="mt-0.5 font-lato text-sm font-medium text-blue-950">{{ i.name }}</p>
            </div>
          }
          @if (i.phone1) {
            <div>
              <p class="font-lato text-xs text-brand-muted">Phone</p>
              <p class="mt-0.5 font-lato text-sm font-medium text-blue-950">{{ i.phone1 }}</p>
            </div>
          }
          @if (i.email) {
            <div class="col-span-2">
              <p class="font-lato text-xs text-brand-muted">Email</p>
              <a href="mailto:{{ i.email }}" class="mt-0.5 block font-lato text-sm font-medium text-blue-600 hover:underline">{{ i.email }}</a>
            </div>
          }
          @if (i.phone2) {
            <div>
              <p class="font-lato text-xs text-brand-muted">Secondary phone</p>
              <p class="mt-0.5 font-lato text-sm font-medium text-blue-950">{{ i.phone2 }}</p>
            </div>
          }
        </div>
      </div>
    }
  </div>
</div>
